export default "__VITE_ASSET__125a52ee__"